import React, { useState, useEffect, useRef } from 'react';
import { getPPDApi } from '../../../services/OtherService';
import DataLoader from '../Dashboard/Loader';
import { Link, useParams } from 'react-router-dom';
import PreviewPPD from './PreviewPPD';
import ApproveReviewModal from './ApproveReviewModal';
import { connect } from 'react-redux';

const ViewPPDPage = ({ user }) => {
    const [data, setData] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const { id } = useParams()
    const printRef = useRef(null)

    useEffect(() => {
        setIsLoading(true)
        getPPDApi(id).then((resp) => {
            setData(resp.data)
            setIsLoading(false)
        }).catch((error) => {
            console.log(error.response.data)
            setIsLoading(false)
        })

    }, [])

    const handleStatusUpdated = (updatedData) => {
        setData({ ...updatedData })
    }

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        const printContent = printRef.current.innerHTML;

        const styles = `
            <style>
                .page-body {
                    font-family: Arial, Helvetica, sans-serif !important;
                    font-size: 14px;
                    width: 100%;
                    max-width: 1000px;
                    margin: auto;
                    padding: 20px 40px;
                    overflow-x: auto;
                    color: #000;
                    background-color: white;
                }
    
                p {
                    font-size: 14px !important;
                }
    
                .page-info {
                    text-align: right;
                    font-size: 12px;
                    padding-right: 20px;
                }
    
                .page-header {
                    text-align: center;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
    
                .demand-info {
                    width: 100%;
                    margin-bottom: 10px;
                }
    
                .demand-info,
                .demand-info td {
                    border: none;
                }
    
                .demand-info td:first-child {
                    padding-right: 40px;
                }
    
                .demand-item {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 10px;
                }
    
                .demand-item th,
                .demand-item td {
                    border: 1px solid #000 !important;
                    padding: 2px 4px;
                    text-align: left;
                }
        
                .page-break {
                    page-break-before: always;
                    margin-top: 10px;
                }
    
                .hr-border {
                    height: 2px; 
                    border-width: 0;  
                    background-color: #4e4c4c;
                    margin: 0 !important;
                    opacity: 1 !important;
                }
    
                .float-left {
                    float: left;
                }
    
                .float-right {
                    float: right;
                }
    
                .text-center {
                    text-align: center;
                }
    
                .clear-both {
                    clear: both;
                }
    
                /* Media Print Styles */
                @media print {
                    body {
                        background-color: white;
                        margin: 0; 
                        padding: 0;
                        transform: scale(0.96); 
                        transform-origin: top left; 
                    }
    
                    .page-body {
                        padding: 10px;
                        max-width: 100%;
                        font-size: 12px;
                    }
    
                    .page-header {
                        font-size: 16px;
                    }
                    
                    p {
                        font-size: 1rem !important;
                    }
                    
                    li{
                        font-size:1rem;
                    }
    
                    .demand-item th, 
                    .demand-item td {
                        padding: 2px;
                    }
    
                    .no-print {
                        display: none !important;
                    }
    
                    .page-break {
                        page-break-before: always;
                    }
                    @page {
                        size: auto;
                        margin: 0;
                    }

                }
            </style>
        `;

        printWindow.document.write(`
            <html>
            <head>
                <title>${data?.mmg_demand_no || ""}</title>
                ${styles}
            </head>
            <body>
                <div class="page-body">${printContent}</div>
            </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.onload = () => {
            setTimeout(() => {
                printWindow.focus();
                printWindow.print();
                printWindow.close();
            }, 200);
        };
    };





    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                {isLoading ? (<DataLoader />) : (<div>
                                    <div className='d-flex align-itemc-center justify-content-between border-bottom px-3 py-2'>
                                        <div className="d-flex align-items-center">
                                            <Link to="/purchase-demand"
                                                className="btn btn-outline-primary btn-sm rounded-circle"
                                                style={{ padding: "5px 9px" }}
                                            ><i className="fa-solid fa-arrow-left"></i></Link>
                                            <h4 className="mb-0 ms-2">{data?.mmg_demand_no}</h4>
                                        </div>
                                        <div>
                                            <button className='btn btn-outline-info me-2' onClick={handlePrint}>Print PPD</button>
                                            {(data?.initiated_by?.id === user?.id && data?.status !== "Approved") &&
                                                <Link to={`/edit-purchase-demand/${id}`} className='btn btn-outline-primary'>Edit PPD</Link>
                                            }
                                        </div>
                                    </div>

                                    <div className='my-3 px-3 d-flex align-items-center justify-content-between'>
                                        <div className='card p-3'>
                                            <h5>Initiated By</h5>
                                            <div className='d-flex flex-column'>
                                                <span className='fw-semibold'>{data?.initiated_by.name}</span>
                                                <span>{data?.initiated_at}</span>
                                            </div>
                                        </div>
                                        {data?.reviewed_by && (
                                            <div className='card p-3'>
                                                <h5>Reviewed By</h5>
                                                <div className='d-flex flex-column'>
                                                    <span className='fw-semibold'>{data?.reviewed_by.name}</span>
                                                    <span>{data?.reviewed_at}</span>
                                                </div>
                                            </div>
                                        )}

                                        {data?.rejected_by && (
                                            <div className='card p-3 bg-danger text-white'>
                                                <h5 className='text-white'>Rejected By</h5>
                                                <div className='d-flex flex-column'>
                                                    <span className='fw-semibold'>{data?.rejected_by.name}</span>
                                                    <span>{data?.rejected_at}</span>
                                                </div>
                                            </div>
                                        )}

                                        {data?.approved_by && (
                                            <div className='card p-3 bg-success text-white'>
                                                <h5 className='text-white'>Approved By</h5>
                                                <div className='d-flex flex-column'>
                                                    <span className='fw-semibold'>{data?.approved_by.name}</span>
                                                    <span>{data?.approved_at}</span>
                                                </div>
                                            </div>
                                        )}

                                        <div className='card p-3'>
                                            <h5>Status</h5>
                                            {data &&
                                                <ApproveReviewModal data={
                                                    {
                                                        id: data.id,
                                                        status: data.status,
                                                        rejected_reason: data.rejected_reaason,
                                                        reviewed_by: data.reviewed_by,
                                                        rejected_reason: data?.rejected_reason
                                                    }}
                                                    handleAfterApproved={handleStatusUpdated} />
                                            }
                                        </div>
                                    </div>

                                    {data?.rejected_reason && <p className='text-danger px-3 text-center'><strong>Rejected Reason: </strong>{data?.rejected_reason}</p>}


                                    {data !== null &&
                                        <div className='p-5 mt-2' style={{ background: "#969998" }}>
                                            <div ref={printRef}>
                                                <PreviewPPD props={data} />
                                            </div>
                                        </div>
                                    }
                                </div>)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    user: state.auth.user,
});
export default connect(mapStateToProps)(ViewPPDPage);
